export default __webpack_public_path__ + "static/media/P-018.da54b94a.png";